import { SelectQueryBuilder } from 'kysely'
import { Database } from '../database'

export type BrowserLastUsageFilters = {
  createdBefore?: string
  createdAfter?: string
  updatedBefore?: string
  updatedAfter?: string
  deletedBefore?: string
  deletedAfter?: string
  search?: string
  deployment_ids?: string[]
  timestampBefore?: string
  timestampAfter?: string
}

export type BrowserLastUsageBySoftwareFilters = {
  search?: string
  deploymentId?: string
}

export function applyBrowserLastUsageFilters<T>(
  query: SelectQueryBuilder<Database, 'browser_last_usage', T>,
  filters: BrowserLastUsageFilters
): SelectQueryBuilder<Database, 'browser_last_usage', T> {
  if (filters.createdBefore) {
    query = query.where(
      'browser_last_usage.created',
      '<',
      filters.createdBefore
    )
  }
  if (filters.createdAfter) {
    query = query.where('browser_last_usage.created', '>', filters.createdAfter)
  }
  if (filters.updatedBefore) {
    query = query.where(
      'browser_last_usage.updated',
      '<',
      filters.updatedBefore
    )
  }
  if (filters.updatedAfter) {
    query = query.where('browser_last_usage.updated', '>', filters.updatedAfter)
  }
  if (filters.deletedBefore) {
    query = query.where(
      'browser_last_usage.deleted_at',
      '<',
      filters.deletedBefore
    )
  }
  if (filters.deletedAfter) {
    query = query.where(
      'browser_last_usage.deleted_at',
      '>',
      filters.deletedAfter
    )
  }
  if (filters.search) {
    query = query.where((eb) =>
      eb.or([
        eb('browser_last_usage.software_name', 'like', `%${filters.search}%`),
        // eb('browser_deployment.name', 'like', `%${filters.search}%`),
      ])
    )
  }
  if (filters.timestampBefore) {
    query = query.where(
      'browser_last_usage.timestamp',
      '<',
      filters.timestampBefore
    )
  }
  if (filters.timestampAfter) {
    query = query.where(
      'browser_last_usage.timestamp',
      '>',
      filters.timestampAfter
    )
  }
  if (filters.deployment_ids?.length) {
    // Use 'in' operator for array matching (works with SQLite/IndexedDB)
    query = query.where(
      'browser_last_usage.deployment_id',
      'in',
      filters.deployment_ids
    )
  }

  return query
}

export function applyBrowserLastUsageBySoftwareFilters<T>(
  query: SelectQueryBuilder<Database, 'browser_last_usage', T>,
  filters: BrowserLastUsageBySoftwareFilters
): SelectQueryBuilder<Database, 'browser_last_usage', T> {
  if (filters.search) {
    query = query.where((eb) =>
      eb.or([
        eb('browser_last_usage.software_name', 'like', `%${filters.search}%`),
        // eb('browser_deployment.name', 'like', `%${filters.search}%`),
      ])
    )
  }
  if (filters.deploymentId) {
    query = query.where(
      'browser_last_usage.deployment_id',
      '=',
      filters.deploymentId
    )
  }

  return query
}
